"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_LAST_N_DAYS = void 0;
exports.DASHBOARD_LAST_N_DAYS = 30;
